import { Component, inject, OnInit } from '@angular/core';
import {
  BackendDataSourceService,
  ItemView,
  ItemViewProviderDirective,
  NtapCommonComponent
} from '@ntap/core';
import { switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-spremiste-lokacije',
  templateUrl: './spremiste-lokacije.component.html',
  styleUrls: ['./spremiste-lokacije.component.scss']
})
export class SpremisteLokacijeComponent
  extends NtapCommonComponent
  implements OnInit
{
  parentSpremisnaJedinicaName: any;
  constructor(protected itemViewProvider: ItemViewProviderDirective<ItemView>) {
    super();
  }
  backendService = inject(BackendDataSourceService);

  parentArchiveName: string;
  parentObjectName: string;
  parentProstorijaName: string;
  parentProstorijaArea: string;
  parentObjectAdress: string;
  parentObjectArea: string;
  lokacijaName: string;

  ngOnInit() {
    // FIXME injectati ArhivSelectorProvider (providamo ga na root listi - Objekti) i iz njega pročitati trenutno odabrani selectedArhivId$.
    // Nakon toga postaviti taj arhivId u arhiv_id preko forme ili preko providera
    this.addSubscription(
      this.itemViewProvider.item$
        .pipe(
          switchMap((item: any) => {
            this.lokacijaName =
              (item['earhiv~spremiste_lokacija~identifikator']
                ? item['earhiv~spremiste_lokacija~identifikator']
                : '') +
              ' ' +
              (item['earhiv~spremiste_lokacija~naziv']
                ? item['earhiv~spremiste_lokacija~naziv']
                : '');

            return this.backendService.getViewData(
              'spremiste_spremisne-jedinice',
              {
                ['earhiv~spremiste_spremisna_jedinica~id']:
                  item['earhiv~spremiste_spremisna_jedinica~id']
              }
            );
          }),
          tap((parentSpremisnaJedinica: any) => {
            this.parentSpremisnaJedinicaName =
              (parentSpremisnaJedinica[0][
                'earhiv~spremiste_spremisna_jedinica~identifikator'
              ]
                ? parentSpremisnaJedinica[0][
                    'earhiv~spremiste_spremisna_jedinica~identifikator'
                  ] + ' '
                : '') +
              (parentSpremisnaJedinica[0][
                'earhiv~spremiste_spremisna_jedinica~naziv'
              ]
                ? parentSpremisnaJedinica[0][
                    'earhiv~spremiste_spremisna_jedinica~naziv'
                  ]
                : '');
          }),
          switchMap((parentSpremisnaJedinica: any) => {
            return this.backendService.getViewData('spremiste_prostorije', {
              ['earhiv~spremiste_prostorija~id']:
                parentSpremisnaJedinica[
                  'earhiv~spremiste_spremisna_jedinica~spremiste_prostorija_id'
                ]
            });
          }),
          tap((parentProstorija: any) => {
            this.parentProstorijaName =
              parentProstorija[0]['earhiv~spremiste_prostorija~identifikator'] +
              ' ' +
              parentProstorija[0]['earhiv~spremiste_prostorija~naziv'];
            this.parentProstorijaArea =
              parentProstorija.length > 0 &&
              parentProstorija[0]['earhiv~spremiste_prostorija~povrsina'];
          }),
          switchMap((parentProstorija: any) => {
            return this.backendService.getViewData('spremiste_objekti', {
              ['earhiv~spremiste_objekt~id']:
                parentProstorija[
                  'earhiv~spremiste_prostorija~spremiste_objekt_id'
                ]
            });
          }),
          tap((parentObjekt: any) => {
            this.parentObjectName =
              parentObjekt[0]['earhiv~spremiste_objekt~identifikator'] +
              ' ' +
              parentObjekt[0]['earhiv~spremiste_objekt~naziv'];
            this.parentObjectAdress =
              parentObjekt.length > 0 &&
              parentObjekt[0]['earhiv~spremiste_objekt~adresa'];
            this.parentObjectArea =
              parentObjekt.length > 0 &&
              parentObjekt[0]['earhiv~spremiste_objekt~povrsina'];
          }),
          switchMap((parentObjekt: any) =>
            this.backendService
              .getViewData('spremiste_nadredeni-arhiv', {
                'en~arhiv_posjednik~id':
                  parentObjekt[0]['earhiv~spremiste_objekt~arhiv_id']
              })
              .pipe(
                tap((parentArhiv: any) => {
                  this.parentArchiveName =
                    parentArhiv.length > 0 && parentArhiv[0]['en~agent~naziv'];
                })
              )
          )
        )
        .subscribe()
    );
  }
}
